
// constants as defined in RevoXef’s App\Models\TableDesigner\TableTable
const SQUARE = 1
const ROUND = 2
// const WALL = 3
// const TEXT = 4

export default {
  SQUARE,
  ROUND,
  isTable: v => v === null || [SQUARE, ROUND].indexOf(v) !== -1,
}
